import React from 'react';
import { CloseDayForm } from './CloseDayForm';

const closeDayRoutes = [
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/outlet-setting/:outletID/close-day`,
		},
		component: <CloseDayForm />,
	},
];

export default closeDayRoutes;
